import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import DAPrice from './DAPrice';

const normalizePath = (path = '') => path.replace(/^\/static/, '/media');

const ForwardCurve = ({ rootPath, initialPath, ...rest }) => {
    const normalizedRootPath = useMemo(() => normalizePath(rootPath), [rootPath]);
    const normalizedInitialPath = useMemo(
        () => (initialPath ? normalizePath(initialPath) : undefined),
        [initialPath]
    );

    return (
        <DAPrice
            {...rest}
            rootPath={normalizedRootPath}
            initialPath={normalizedInitialPath}
            defaultDownloadFolderName="forward-prices"
        />
    );
};

ForwardCurve.propTypes = {
    rootPath: PropTypes.string.isRequired,
    initialPath: PropTypes.string,
    title: PropTypes.string,
    breadcrumbRootLabel: PropTypes.string,
    searchPlaceholders: PropTypes.object,
    levelLabels: PropTypes.object,
    onFileOpen: PropTypes.func
};

ForwardCurve.defaultProps = {
    initialPath: undefined,
    title: 'Forward Curve'
};

export default ForwardCurve;